import { IUserStatus } from "../modules/UserStatus/UserStatuses.t";
import { createSlice } from "@reduxjs/toolkit";
import { LOGOUT_SUCCESS } from "../modules/Login/loginConstants";
import { INotificationMessageRespawnMotivationPayload } from "../modules/Notifications/notifications.t";

export interface IUserReducer {
    userStatuses: IUserStatus[],
    userStatusesError: string,
    userStatusesLoading: boolean,

    respawnMotivation: INotificationMessageRespawnMotivationPayload | null;
}

const initialState: IUserReducer = {
    userStatuses: [],
    userStatusesError: '',
    userStatusesLoading: false,

    respawnMotivation: null,
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        getUserStatusesAction(state) {
            state.userStatusesError = '';
            state.userStatusesLoading = true;
        },
        getUserStatusesSuccess(state, action) {
            state.userStatuses = action.payload;
            state.userStatusesLoading = false;
        },
        getUserStatusesFailure(state, action) {
            state.userStatusesError = action.payload;
            state.userStatusesLoading = false;
        },
        setRespawnMotivation(state, action) {
            state.respawnMotivation = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT_SUCCESS, (state) => {
            return {
                ...initialState,
            }
        })
    },
});

export default userSlice.reducer;
